import React from 'react';
import { CTAButton, SHOPIFY_URL } from './ui/CTAButton';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-gray-900 text-white text-center" data-id="element-81">
      <div className="max-w-4xl mx-auto" data-id="element-82">
        <h2 className="text-4xl md:text-6xl font-black mb-8 leading-tight" data-id="element-83">
          Lectura y escritura no tienen por qué ser una batalla
        </h2>

        <p className="text-xl md:text-2xl text-gray-300 font-medium mb-12 max-w-2xl mx-auto" data-id="element-84">
          No necesitás más PDFs sueltos. Necesitás un sistema claro, imprimible
          y progresivo que te diga qué hacer, cómo y en qué orden.
        </p>

        <CTAButton text="👉 Accedé ahora al MEGA KIT LECTOESCRITURA" className="max-w-2xl mx-auto" href={SHOPIFY_URL} data-id="element-85" />
      </div>
    </section>;
}